/** Product identity shown to users; change here only. */
export const productName = 'Pro Guard';
export const productTagline = 'Plataforma de Vídeo Monitoramento';
/** Release number, from backend/VERSION at build time. */
export const productVersion = __APP_VERSION__;
